import { Injectable } from '@angular/core';
import { WorkQueueService } from '@core/services//work-queue//work-queue.service';
import { WorkQueueDetails } from '@core/services/work-queue/work-queue.model';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as usMoveQueueActions from '../us-queue/us-queue.actions';

@Injectable()
export class UsQueueEffect {
  constructor(private actions$: Actions, private workQueueService: WorkQueueService) { }

  
  loadusmovequeues$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<usMoveQueueActions.LOADUSMOVEQUEUE>(
      usMoveQueueActions.USMoveQueueActionTypes.LOAD_USMOVEQUEUE
    ),
    mergeMap((action: usMoveQueueActions.LOADUSMOVEQUEUE) =>
      this.workQueueService.GetWorkQueue(action.queuetype, action.workqueueStatusId, action.accountUpdateOptionId, action.customerFollowUpOptionId, action.investigationOptionId, action.insuranceFollowUpOptionId).pipe(
        map(
          (usmovedetails: WorkQueueDetails) =>
            new usMoveQueueActions.LOADUSMOVEQUEUESUCCESS(usmovedetails)
        ),
        catchError(err => of(new usMoveQueueActions.LOADUSMOVEQUEUEFAIL(err)))
      )
    )
  ));
}
